module.exports = __webpack_public_path__ + "static/img/pic_jiantou.64ac057b.png";